import { createConfig, fallback, http } from 'wagmi';
import { berachainTestnetbArtio } from 'viem/chains';

import { walletConnect, injected, safe, coinbaseWallet } from 'wagmi/connectors';

import { ALL_CHAINS } from '../data/constants/ChainSpecific';
import { Transport } from 'viem';
import { DEFAULT_CHAIN } from '../data/constants/Values';

const transports: { [chainId: number]: Transport[] } = Object.fromEntries(ALL_CHAINS.map((c) => [c.id, []]));

// Alchemy endpoints
if (process.env.REACT_APP_ALCHEMY_API_KEY) {
  transports[berachainTestnetbArtio.id].push(
    http(`https://berachain-bartio.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_API_KEY}`)
  );
}

// Public endpoint alternatives
transports[berachainTestnetbArtio.id].push(
  http('https://bartio.rpc.berachain.com')
);
// transports[berachainTestnetbArtio.id].push(
//   http('https://bera-testnet.nodeinfra.com')
// );
// transports[berachainTestnetbArtio.id].push(
//   http('https://bartio.rpc.b-harvest.io')
// );

const projectId = process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID!;
const metadata = {
  name: 'Stacking Salmon',
  description: 'Permissionless stacking of ze sammin.',
  url: 'https://www.stackingsalmon.com',
  icons: ['https://avatars.githubusercontent.com/u/173576673'],
};

export const wagmiConfig = createConfig({
  chains: ALL_CHAINS,
  connectors: [
    injected({ shimDisconnect: true }),
    walletConnect({
      projectId,
      metadata,
      showQrModal: true,
      qrModalOptions: {
        themeMode: 'dark',
        termsOfServiceUrl: 'https://www.stackingsalmon.com/terms-of-service',
      },
    }),
    coinbaseWallet({
      appName: metadata.name,
      // appLogoUrl: // TODO: do better than favicon
      chainId: DEFAULT_CHAIN.id,
      preference: 'all',
    }),
    safe(),
  ],
  batch: {
    multicall: {
      batchSize: 2048,
      wait: 500,
    },
  },
  cacheTime: 4000,
  pollingInterval: 4000,
  transports: {
    [berachainTestnetbArtio.id]: fallback(transports[berachainTestnetbArtio.id], { rank: false }),
  },
});

// TODO: seems like it could be useful, but breaks things rn
// declare module 'wagmi' {
//   interface Register {
//     config: typeof wagmiConfig
//   }
// }
